/* gl_textarea.directive.js */

"use strict";
/* globals angular */
const _ = require("lodash");
module.exports = function ($compile) {
    return {
        restrict: "E",
        scope: {
            settings: "=",
            api: "=",
        },
        link: function (scope, element /*, attrs, controller*/) {
            let childScope = scope.$new();

            let elementAll;
            let elementTextarea;
            let elementError;
            let elementLabel;
            let elementValue;

            let classEmpty = "gl-empty";
            let classInvalid = "gl-invalid";
            let classFocus = "gl-focus";
            let classDisabled = "gl-disabled";

            const templateAll = '<div class="gl-textarea-container"></div>'; // necessary to house textarea and superscroll elements.
            elementAll = angular.element(templateAll);

            scope.api = angular.isUndefined(scope.api) ? {} : scope.api;
            scope.settings = angular.isUndefined(scope.settings) ? {} : scope.settings;

            scope._settings = {};

            scope._settings = {
                autoScrollToBottom: false,
                id: undefined,
                name: undefined,
                value: undefined,
                valid: true,
                label: undefined,
                disabled: false,
                placeholder: undefined,
                error: undefined,
                editable: true,
                showLabel: false,
            };

            _.assignWith(scope._settings, scope.settings);

            // MAP SETTINGS
            scope._settings.onKeyDown = angular.isFunction(scope.settings.onKeyDown)
                ? scope.settings.onKeyDown
                : undefined;
            scope._settings.onKeyPress = angular.isFunction(scope.settings.onKeyPress)
                ? scope.settings.onKeyPress
                : undefined;
            scope._settings.onKeyUp = angular.isFunction(scope.settings.onKeyUp)
                ? scope.settings.onKeyUp
                : undefined;
            scope._settings.onInput = angular.isFunction(scope.settings.onInput)
                ? scope.settings.onInput
                : undefined;
            scope._settings.onFocus = angular.isFunction(scope.settings.onFocus)
                ? scope.settings.onFocus
                : undefined;
            scope._settings.onBlur = angular.isFunction(scope.settings.onBlur)
                ? scope.settings.onBlur
                : undefined;
            scope._settings.onMouseOver = angular.isFunction(scope.settings.onMouseOver)
                ? scope.settings.onMouseOver
                : undefined;
            scope._settings.onMouseOut = angular.isFunction(scope.settings.onMouseOut)
                ? scope.settings.onMouseOut
                : undefined;
            scope._settings.onMouseMove = angular.isFunction(scope.settings.onMouseMove)
                ? scope.settings.onMouseMove
                : undefined;
            scope._settings.onMouseDown = angular.isFunction(scope.settings.onMouseDown)
                ? scope.settings.onMouseDown
                : undefined;
            scope._settings.onMouseUp = angular.isFunction(scope.settings.onMouseUp)
                ? scope.settings.onMouseUp
                : undefined;
            scope._settings.onChange = angular.isFunction(scope.settings.onChange)
                ? scope.settings.onChange
                : undefined;
            scope._settings.onValueChange = angular.isFunction(scope.settings.onValueChange)
                ? scope.settings.onValueChange
                : undefined;

            let templateTextarea = '<textarea class="gl-textarea-input" data-gl-super-scroll ';
            templateTextarea += scope._settings.id ? ' id="{{_settings.id}}" ' : "";
            templateTextarea += scope._settings.title ? ' title="{{_settings.title}}" ' : "";
            templateTextarea += scope._settings.name ? ' name="{{_settings.name}}" ' : "";
            templateTextarea += scope._settings.placeholder
                ? ' data-ng-attr-placeholder="{{_settings.placeholder}}" '
                : "";
            templateTextarea +=
                ' data-ng-model="_settings.value" data-gramm_editor="false"></textarea>';
            let templateError = '<p class="gl-textarea-error">{{_settings.error}}</p>';
            let templateLabel =
                '<label class="gl-textarea-view-label" data-ng-show="_settings.showLabel">{{_settings.label}}</label>';
            let templateValue = '<p class="gl-textarea-view-value">{{_settings.value}}</p>';

            const setViewMode = function () {
                scope._settings.editable = false;
                element.children().remove();

                if (angular.isString(scope._settings.label)) {
                    elementLabel = $compile(angular.element(templateLabel))(scope);
                    element.append(elementLabel);
                }

                elementValue = $compile(angular.element(templateValue))(scope);
                element.append(elementValue);
            };

            let getInputEl = function () {
                elementTextarea = angular.element(templateTextarea);
                elementTextarea.attr("type", scope._settings.type);
                elementTextarea.val(scope._settings.value);

                if (scope._settings.disabled) {
                    elementTextarea.attr("disabled", true);
                    elementAll.addClass(classDisabled);
                }

                if (angular.isString(scope._settings.value) && scope._settings.value !== "") {
                    elementTextarea.removeClass(classEmpty);
                } else {
                    elementTextarea.addClass(classEmpty);
                }

                // event bindings
                if (!angular.isUndefined(scope._settings.onKeyDown)) {
                    elementTextarea.bind("keydown", function (evt) {
                        scope._settings.onKeyDown(evt);
                    });
                }
                if (!angular.isUndefined(scope._settings.onKeyUp)) {
                    elementTextarea.bind("keyup", function (evt) {
                        scope._settings.onKeyUp(evt);
                    });
                }
                if (!angular.isUndefined(scope._settings.onKeyPress)) {
                    elementTextarea.bind("keypress", function (evt) {
                        scope._settings.onKeyPress(evt);
                    });
                }
                if (!angular.isUndefined(scope._settings.onInput)) {
                    elementTextarea.bind("input", function (evt) {
                        scope._settings.onInput(evt);
                    });
                }
                if (!angular.isUndefined(scope._settings.onFocus)) {
                    elementTextarea.bind("focus", function (evt) {
                        scope._settings.onFocus(evt);
                    });
                }
                if (!angular.isUndefined(scope._settings.onBlur)) {
                    elementTextarea.bind("blur", function (evt) {
                        scope._settings.onBlur(evt);
                    });
                }
                if (!angular.isUndefined(scope._settings.onMouseOver)) {
                    elementTextarea.bind("mouseover", function (evt) {
                        scope._settings.onMouseOver(evt);
                    });
                }
                if (!angular.isUndefined(scope._settings.onMouseOut)) {
                    elementTextarea.bind("mouseout", function (evt) {
                        scope._settings.onMouseOut(evt);
                    });
                }
                if (!angular.isUndefined(scope._settings.onMouseMove)) {
                    elementTextarea.bind("mousemove", function (evt) {
                        scope._settings.onMouseMove(evt);
                    });
                }
                if (!angular.isUndefined(scope._settings.onMouseDown)) {
                    elementTextarea.bind("mousedown", function (evt) {
                        scope._settings.onMouseDown(evt);
                    });
                }
                if (!angular.isUndefined(scope._settings.onMouseUp)) {
                    elementTextarea.bind("mouseup", function (evt) {
                        scope._settings.onMouseUp(evt);
                    });
                }
                if (!angular.isUndefined(scope._settings.onChange)) {
                    elementTextarea.bind("change", function (evt) {
                        scope._settings.onChange(evt);
                    });
                }

                elementTextarea.bind("focus", function () {
                    elementAll.addClass(classFocus);
                });
                elementTextarea.bind("blur", function () {
                    elementAll.removeClass(classFocus);
                });

                return elementTextarea;
                //return $compile(elementTextarea)(scope);
            };

            const errorMsgCheck = function () {
                if (!angular.isUndefined(elementError)) {
                    elementError.remove();
                }
                if (scope._settings.editable) {
                    if (scope._settings.valid) {
                        elementTextarea.removeClass(classInvalid);
                        elementAll.removeClass(classInvalid);
                    } else {
                        elementTextarea.addClass(classInvalid);
                        elementAll.addClass(classInvalid);
                        if (angular.isString(scope._settings.error)) {
                            elementError = angular.element(templateError);
                            element.append($compile(elementError)(scope));
                        }
                    }
                }
            };

            const emptyCheck = function () {
                if (!angular.isUndefined(elementTextarea)) {
                    if (_.isEmpty(scope._settings.value)) {
                        elementTextarea.addClass(classEmpty);
                        elementAll.addClass(classEmpty);
                    } else {
                        elementTextarea.removeClass(classEmpty);
                        elementAll.removeClass(classEmpty);
                    }
                }
            };

            const setEditMode = function () {
                childScope.$destroy();
                element.children().remove();
                childScope = scope.$new();

                if (angular.isString(scope._settings.label)) {
                    elementLabel = $compile(angular.element(templateLabel))(scope);
                    element.append(elementLabel);
                }

                elementAll = angular.element(templateAll);
                scope._settings.editable = true;
                elementAll.append(getInputEl());
                element.append($compile(elementAll)(childScope));
                errorMsgCheck();
                emptyCheck();
            };

            scope.api.view = function () {
                setViewMode();
            };
            scope.api.edit = function () {
                setEditMode();
            };

            scope.api.setInvalid = function (msg) {
                scope._settings.valid = false;
                if (angular.isString(msg)) {
                    scope._settings.error = msg;
                } else {
                    scope._settings.error = undefined;
                }
                errorMsgCheck();
            };

            scope.api.setValid = function () {
                scope._settings.valid = true;
                errorMsgCheck();
            };

            scope.api.setValue = function (val, scrolltoBottom) {
                scope._settings.value = val;
                if (scope._settings.autoScrollToBottom || scrolltoBottom) {
                    let scrollArea = elementAll.find(".gl-textarea-input");
                    _.defer(function () {
                        scrollArea.scrollTop(scrollArea[0].scrollHeight);
                    });
                }
            };

            scope.api.getValue = function () {
                return elementTextarea.val();
            };

            scope.api.setLabel = function (label) {
                scope._settings.label = label;
            };

            scope.api.getLabel = function () {
                return scope._settings.label;
            };

            scope.api.setPlaceholder = function (placeholder) {
                scope._settings.placeholder = placeholder;
            };

            scope.api.getPlaceholder = function () {
                return scope._settings.placeholder;
            };

            scope.api.disable = function () {
                scope._settings.disabled = true;
                elementTextarea.attr("disabled", true);
                elementAll.addClass(classDisabled);
            };

            scope.api.enable = function () {
                scope._settings.disabled = false;
                elementTextarea.removeAttr("disabled");
                elementAll.removeClass(classDisabled);
            };

            let unregisterWatch = scope.$watch("_settings.value", function (n, o) {
                emptyCheck();
                if (angular.isFunction(scope._settings.onValueChange)) {
                    scope._settings.onValueChange(n, o);
                }
            });

            scope.$on("$destroy", function () {
                onDestruction();
            });

            function onDestruction() {
                unregisterWatch();
                if (!angular.isUndefined(scope._settings.onKeyDown)) {
                    elementTextarea.unbind("keydown");
                }
                if (!angular.isUndefined(scope._settings.onKeyUp)) {
                    elementTextarea.unbind("keyup");
                }
                if (!angular.isUndefined(scope._settings.onKeyPress)) {
                    elementTextarea.unbind("keypress");
                }
                if (!angular.isUndefined(scope._settings.onInput)) {
                    elementTextarea.unbind("input");
                }
                if (!angular.isUndefined(scope._settings.onMouseOver)) {
                    elementTextarea.unbind("mouseover");
                }
                if (!angular.isUndefined(scope._settings.onMouseOut)) {
                    elementTextarea.unbind("mouseout");
                }
                if (!angular.isUndefined(scope._settings.onMouseMove)) {
                    elementTextarea.unbind("mousemove");
                }
                if (!angular.isUndefined(scope._settings.onMouseDown)) {
                    elementTextarea.unbind("mousedown");
                }
                if (!angular.isUndefined(scope._settings.onMouseUp)) {
                    elementTextarea.unbind("mouseup");
                }
                if (!angular.isUndefined(scope._settings.onChange)) {
                    elementTextarea.unbind("change");
                }
            }

            // INIT

            if (scope._settings.editable) {
                setEditMode();
            } else {
                setViewMode();
            }

            //if(!angular.isUndefined(scope._settings.view) && scope._settings.view == true){
            //    setViewMode();
            //}else{
            //    setEditMode();
            //}
        },
    };
};

/*Generated Injectables*/
module.exports.$inject=['$compile'];